import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../../../user/selectors'
import { getBurnsSelector } from '../selectors'
import { IBurnsState } from '../store/burns.types'
import { PcrDocsService } from '../../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../../home/selectors'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'
import { BurnsConstants } from '../store/burns.constants'
import { setBodValue } from '../../bodySurvey/store/bodySurvey.actions'
import { compareObjectsIfEqual, filterOutObjectKeys } from '../../../../../utilities/object.util'
import { initialBurnsState } from '../store/burns.reducers'

export function* saveBurns() {
  const burnsStateData: IBurnsState = yield select(getBurnsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  try {
    if (pcrID) {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const { additionalBurnInformation, ...otherBurnsData } = burnsStateData
      let pcrDocUpdated: IPcr = { ...pcrDoc }

      const fieldsToFilter = ['isTBSA']
      const currentState = filterOutObjectKeys(burnsStateData, fieldsToFilter)
      const initalState = filterOutObjectKeys(initialBurnsState, fieldsToFilter)

      if (compareObjectsIfEqual(currentState, initalState)) {
        pcrDocUpdated = {
          ...pcrDoc,
          additionalAssessment: {
            ...pcrDoc.additionalAssessment,
            burns: undefined,
          },
        }
      } else {
        pcrDocUpdated = {
          ...pcrDoc,
          additionalAssessment: {
            ...pcrDoc.additionalAssessment,
            burns: {
              ...otherBurnsData,
              additionalBurnInformation: additionalBurnInformation,
            },
          },
        }
        yield put(setBodValue(true))
      }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    }
  } catch (e) {
    yield put(throwPcrException(`saveBurns() error: ${e}`))
  }
}

export function* saveBurnsSaga() {
  yield takeLatest([BurnsConstants.SAVE_BURNS, BurnsConstants.RESET_BURNS_TBSA], performWithMutexHOG, saveBurns)
}
